import typography from '~/styles/typography'

import { width, device } from './device'
import { lightTheme } from './mode'
import palette from './palette'

const height = {
  header: 50,
  footer: 86,
}

const padding = {
  desktop: 20,
}

const zIndex = {
  header: 100,
}

const theme = {
  width,
  device,
  height,
  padding,
  zIndex,
  typography,
  colors: lightTheme,
  palette,
}

export type ThemeType = typeof theme

export default theme
